import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, getToken } from "../../shared/utils.js/utils";
import i18n from "../../i18n/i18n";

// Get Engineers
export const getEngineers = createAsyncThunk(
  "engineers/getEngineers",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) throw new Error("No authentication token found");
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.per_page) queryParams.append("per_page", params.per_page);
      if (params.search) queryParams.append("search", params.search);
      if (
        params.is_active !== undefined &&
        params.is_active !== null &&
        params.is_active !== ""
      ) {
        queryParams.append("is_active", params.is_active);
      }

      const url = `${BASE_URL}/engineers${
        queryParams.toString() ? `?${queryParams.toString()}` : ""
      }`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get Engineers!";
      return rejectWithValue(message);
    }
  },
);

// Get Engineer Details
export const getEngineerDetails = createAsyncThunk(
  "engineers/getEngineerDetails",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.get(`${BASE_URL}/engineers/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get enginner details!";
      return rejectWithValue(message);
    }
  },
);

export const deleteEngineers = createAsyncThunk(
  "engineers/deleteEngineers",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.delete(`${BASE_URL}/engineers/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to delete engineer!";
      return rejectWithValue(message);
    }
  },
);

// Toggle Engineer Status
export const toggleEngineerStatus = createAsyncThunk(
  "engineer/toggleEngineerStatus",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.patch(
        `${BASE_URL}/engineers/${id}/toggle-status`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": i18n.language,
          },
        },
      );
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to toggle Engineer status!";
      return rejectWithValue(message);
    }
  },
);

// Add Engineer
export const addEngineer = createAsyncThunk(
  "engineer/addEngineer",
  async (engineerData, { rejectWithValue }) => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await axios.post(`${BASE_URL}/engineers`, engineerData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response?.data?.errors) {
        const errorMessages = Object.values(error.response.data.errors).flat();
        return rejectWithValue(errorMessages.join(", "));
      }
      const message =
        error.response?.data?.message || "Failed to add Engineer!";
      return rejectWithValue(message);
    }
  },
);

// update Engineer
export const updateEngineer = createAsyncThunk(
  "engineer/updateEngineer",
  async ({ id, engineerData }, { rejectWithValue }) => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await axios.put(
        `${BASE_URL}/engineers/${id}`,
        engineerData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": i18n.language,
          },
        },
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.errors) {
        const errorMessages = Object.values(error.response.data.errors).flat();
        return rejectWithValue(errorMessages.join(", "));
      }
      const message =
        error.response?.data?.message || "Failed to update engineer!";
      return rejectWithValue(message);
    }
  },
);
